export default {
  shopListLink: [],
  messageListLink: [],
  trackerListLink: [],
  sendLinkBroadcast: '',
  saveDataEform: {},
  openStatisticEform: false,
  CampaignId:'',
}
